import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { useDeviationViewContext } from '../../../Context';
import DefaultViewIcon from '../../../Icons/DefaultView';
import TheaterViewIcon from '../../../Icons/TheaterView';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../_partials/items/ActionBarButton';
export var TheaterButton = function (_a) {
    var isTheaterForced = _a.isTheaterForced, deviation = _a.deviation, onClick = _a.onClick;
    var t = useTranslation().t;
    var isTheater = useDeviationViewContext().isTheater;
    return (React.createElement(ActionBarItemWrapper, { tooltip: t("actionbar." + (isTheater ? 'regular' : 'theater') + "View" + (isTheaterForced ? '.disabled' : '')) },
        React.createElement(ActionBarButton, { onClick: function () { return onClick(deviation); }, disabled: isTheaterForced },
            React.createElement(ActionBarIcon, { icon: isTheater ? DefaultViewIcon : TheaterViewIcon }))));
};
TheaterButton.displayName = 'TheaterButton';
export default TheaterButton;
//# sourceMappingURL=TheaterButton.js.map